import { getConnection } from './exactglobe';
import { checkImportExact, clearExistingScheduledImports} from './import';
import { getCookie, getCurrentUser, enableUpdateImports, updateUserLastAction } from './utils';
// Handles exactonline import execution on the server
export async function handleImport(row, updateStatus){
  try {
    handleStatus(updateStatus, true);
    const response = await fetch('/twinfield/executeImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Connection': 'keep-alive',
      },
      body: JSON.stringify({
        entiteit: row.entiteit,
        year: row.year,
        budget_scenario: row.budget_scenario,
        office: row.office,
        user_id: await getCurrentUser(),
      }),
    });

    if (response.ok) {
      // const responseData = await response.json();  
      // return responseData;
      enableUpdateImports();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    handleStatus({"text": "Error!", "progress": 1, "status": 0}, false);
  }
}
export async function getTwinfieldLink(id){
  const response = await fetch('/import_twinfieldlink/getById?id='+id);
  if(response.ok){
    var responseData = await response.json();
    return responseData; 
  }
  else{
    return false;
  }
}
export async function getInvoices(year, office, userId, twinfieldLink){
  try{
    updateUserLastAction();
    const response = await fetch('/twinfield/getInvoices', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        year: year,
        office: office,
        user_id: userId,
        twinfield_link: twinfieldLink
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
//Submits import exact updates/changes
export async function updateImportTwinfield(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_twinfield/updateImportTwinfield', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImportTwinfield(id){
  try { 
    const importResponse = await fetch('/import_twinfield/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();

      await clearExistingScheduledImports({"import_type": "twinfield", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]})
    
      const response = await fetch('/import_twinfield/deleteImportTwinfield?id='+id);
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
        }
      }
  }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}

export async function updateImportFactviewTokens(twinfieldUser){
  const response = await fetch('/import_twinfield/updateFactviewTokens', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      twinfield_user: twinfieldUser,
      factview_access: getCookie('factview_access'),
      factview_refresh: getCookie('factview_refresh'),
    }),
  });
}
// Handles fetching status updates from the server
async function handleStatus(updateStatus, init){
  try{
    if(init){
      await fetch('/twinfield/resetStatus');
      setTimeout(function(){
        handleStatus(updateStatus, false);
      },500);
    }else{
      const response = await fetch('/twinfield/fetchUpdates');
      if (response.ok) {
      const responseData = await response.json();
      
      if(responseData){
        updateStatus(responseData);

        if(responseData.length > 0 && responseData[responseData.length-1]["status"] == 1){
          setTimeout(function(){
            handleStatus(updateStatus, false);
          },400);
        }
      } 
    }
    }
    
    
  } catch(error) {
    setTimeout(function(){
      handleStatus(updateStatus, false);
    },400);
  }
  
}


